import { z } from 'zod';
import { AnnouncementPriority, AnnouncementStatus } from '../types';

/**
 * Mirrors CreateAnnouncementRequestDtoValidator / UpdateAnnouncementRequestDtoValidator on the backend.
 */
export const announcementFormSchema = z
  .object({
    title: z
      .string()
      .min(1, 'Title is required')
      .max(200, 'Title must not exceed 200 characters'),
    content: z
      .string()
      .min(1, 'Content is required')
      .max(10000, 'Content must not exceed 10000 characters'),
    priority: z.nativeEnum(AnnouncementPriority),
    status: z.nativeEnum(AnnouncementStatus),
    isPinned: z.boolean(),
    publishAt: z.string().nullable(),
    expiresAt: z.string().nullable(),
  })
  .refine(
    (data) => {
      if (!data.publishAt || !data.expiresAt) return true;
      return new Date(data.expiresAt) > new Date(data.publishAt);
    },
    {
      message: 'ExpiresAt must be after PublishAt',
      path: ['expiresAt'],
    }
  );

export type AnnouncementFormData = z.infer<typeof announcementFormSchema>;
